var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.048,
    height: 8.048,
    viewBox: "0 0 8.048 8.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_15",
    "data-name": "Ligne 15",
    y2: 6.048,
    transform: "translate(3.024)",
    fill: "none",
    stroke: "#20204e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_16",
    "data-name": "Ligne 16",
    x1: 6.048,
    transform: "translate(0 3.024)",
    fill: "none",
    stroke: "#20204e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicto);
export default __webpack_public_path__ + "static/media/picto+.40800a619ad88b947e78e2cba62330c7.svg";
export { ForwardRef as ReactComponent };